import React, { useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { ThemeProvider as MuiThemeProvider, StylesProvider, CssBaseline } from '@material-ui/core'
import { I18n } from 'aws-amplify'

// Helpers
import { store } from 'configs'
import { dict } from 'i18n'
import { theme, useGlobalStyles } from 'helpers'
import { AppStateProvider } from 'providers'

import { AnalyticsWrapper } from 'components/router/AnalyticsWrapper'

I18n.putVocabularies(dict)

// Init
const App = () => {
  useGlobalStyles()

  useEffect(() => {
    I18n.setLanguage('en')
  }, [])

  return (
    <React.StrictMode>
      <AppStateProvider>
        <Provider store={store}>
          <StylesProvider injectFirst>
            <MuiThemeProvider theme={theme}>
              <CssBaseline />
              <Router basename='/public-sector1'>
                <AnalyticsWrapper />
              </Router>
            </MuiThemeProvider>
          </StylesProvider>
        </Provider>
      </AppStateProvider>
    </React.StrictMode>
  )
}

export default App
